import { Minus, Plus } from "@phosphor-icons/react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import usePromotions from "common/datahooks/usePromotions";
import useNumberSpinner from "common/hooks/useNumberSpinner";

const buttonClassname =
  "p-2 disabled:text-black-400 hover:bg-black-200 rounded-xl transition-[background]";

export default function SeatCountSpinner({
  seatCount,
  setSeatCount,
  agencyLicenseCount,
}: {
  seatCount: number;
  setSeatCount: (seatCount: number) => void;
  agencyLicenseCount: number;
}) {
  const { agencyPlan } = usePromotions();

  const maxValue = agencyLicenseCount + agencyPlan.unassigned_license_count;

  const { inputProps, incrementButtonProps, decrementButtonProps } =
    useNumberSpinner(seatCount, setSeatCount, 0, maxValue);

  const plusButton = (
    <button type="button" className={buttonClassname} {...incrementButtonProps}>
      <Plus className="size-4" />
    </button>
  );

  return (
    <div className="flex bg-black-100 rounded-xl items-center text-black-950 w-fit transition-[background]">
      <button
        type="button"
        className={buttonClassname}
        {...decrementButtonProps}
      >
        <Minus className="size-4" />
      </button>
      <input
        className="w-10 h-7 bg-white rounded-lg p-2 text-center text-button-xs focus-visible:border-purple-500 border focus-visible:outline-none border-white"
        {...inputProps}
      />
      {seatCount >= maxValue ? (
        <Tooltip>
          <TooltipTrigger>{plusButton}</TooltipTrigger>
          <TooltipContent>No more seats available</TooltipContent>
        </Tooltip>
      ) : (
        plusButton
      )}
    </div>
  );
}
